import { Component, OnDestroy, OnInit } from '@angular/core';
import { Subscription, Observable } from 'rxjs';
import { HttpErrorResponse } from '@angular/common/http';
import { FormGroup, FormBuilder, Validators, AbstractControl, ValidationErrors } from '@angular/forms';

import { Session } from '@app/store/models/session.model';
// import { Store } from '@ngrx/store';

import { Organization } from '@core/objects/organization';

import { AppService } from '@app/services/app/app.service';
import { TitleService } from '@core/services/title.service';
import { SettingsOrganizationService } from '@app/services/settings/organization.service';

@Component({
    selector: 'organization-profile-main',
    templateUrl: './main.component.html',
    styleUrls: ['./main.component.scss']
})
export class SettingsOrganizationProfileMainComponent implements OnInit, OnDestroy{
    private readonly ACCESS = 'access_setting_organization_profile';

    public readonly STATUS_LOADING = 0;
    public readonly STATUS_DONE = 1;
    public readonly STATUS_NOT_FOUND = 2;


    public readonly RESPONSE_ERROR_FORBIDDEN = 403;
    public readonly MODAL_VIEW_NONE = 0;
    public readonly MODAL_VIEW_LOGO_UPLOAD_ERROR = 1;
    public readonly MODAL_VIEW_LOGO_UPLOAD_SUCCESS = 2;
    public readonly MODAL_VIEW_LOGO_DELETE_ERROR = 3;
    public readonly MODAL_VIEW_ORGANIZATION_UPDATE_ERROR = 4;
    public readonly MODAL_VIEW_ORGANIZATION_UPDATE_SUCCESS = 5;

    public modalView: number = this.MODAL_VIEW_NONE;
	public access:boolean = true;
    public status: number = 0;

    public errorActions$: Observable<HttpErrorResponse>;  

    public form: FormGroup;
    // public user: User = null;
    public organization: Organization = null;
    public logo: any = null;
    public working: boolean = false;
    private subs: Subscription[] = [];
    public passwordRequested: boolean = false;

    public showLogoEditor: boolean = false;
    public showSaved: boolean = false;
    public saving: boolean = false;
    public breadcrumbs: any = [
        {
            title: "System Settings",
            link: ['/settings']
        }
    ];

	constructor(public app: AppService, 
        private title: TitleService, 
        private formBuilder: FormBuilder, 
        private orgSrv: SettingsOrganizationService){
            this.errorActions$ = this.orgSrv.selectErrorActions();
        }

	ngOnInit(){
         // Use the service method
        this.title.set("Organization Profile");
        this.subs.push( 
            this.app.getSession().subscribe( (session: any) => {
                this.access = session.options.access.hasOwnProperty(this.ACCESS)? session.options.access[this.ACCESS] : false;
                this.working = false;
                if (this.access){
                    this.organization = session.current.organization;
                    this.logo = session.current.organization_logo;
                    this.init();
                }
                if (this.saving){
                    this.showSaved = true;
                }
            })
        );
        this.subs.push( 
            this.orgSrv.selectUploadStatus().subscribe((status:number) => {
                switch (status) {
                    case 1: // Loading
                        this.working = true;
                        break;
                    case 2: // Done
                    case 0: // Assuming 0 is also a "Done" state
                        this.working = false;
                        break;
                    case 3: // Error
                        this.working = false;
                        this.modalView = this.MODAL_VIEW_LOGO_UPLOAD_ERROR;
                        break;
                }
            })
        );
        this.subs.push( 
            this.orgSrv.selectDeleteStatus().subscribe((status:number) => {
                switch (status) {
                    case 1: // Loading
                        this.working = true;
                        break;
                    case 2: // Done
                    case 0: // Assuming 0 is also a "Done" state
                        this.working = false;
                        break;
                    case 3: // Error
                        this.working = false;
                        this.modalView = this.MODAL_VIEW_LOGO_DELETE_ERROR;
                        break;
                }
            })
        );
        this.subs.push( 
            this.orgSrv.selectUpdateStatus().subscribe((status:number) => {
                switch (status) {
                    case 2: // Done
                        this.modalView = this.MODAL_VIEW_ORGANIZATION_UPDATE_SUCCESS;
                    case 3: // Error
                        this.modalView = this.MODAL_VIEW_ORGANIZATION_UPDATE_ERROR;
                        break;
                }
            })
        );
    }

    ngOnDestroy(): void {
        this.subs.forEach((sub: Subscription) => sub.unsubscribe());
    }

    onError(){
        this.orgSrv.clearActionFailures();
        this.modalView = this.MODAL_VIEW_NONE;
    }

    onSuccess(){
        this.orgSrv.clearActionFailures();
        this.modalView = this.MODAL_VIEW_NONE;
    }

    init(){
        
        if(this.organization != null ){
            this.status = this.STATUS_DONE;
        }

        // Name could not be empty or all spaces or length > 20
        this.form = this.formBuilder.group({
            name: [this.organization.name, [Validators.required, this.noWhitespaceValidator, Validators.maxLength(20)]]
        });
    }

    save(){
        // Invalid form or name is empty/all spaces
        if(this.form.invalid)
			return;
        this.saving = true;
        
        this.orgSrv.updateOrganization(this.form.value.name);
    }

    onSavedDone(event){
        this.saving = false;
        this.showSaved = false;
    }

    setLogoWorking(){
        this.working = true;
    }

    public openLogoEditor(){
        this.showLogoEditor = true;
    }


    public closeLogoEditor(){
        this.showLogoEditor = false;
    }

    public formChanged(){
        return (
            this.organization.name != this.form.value.name 
        );
    }

    // Custom validator function to cehck no white spaces in organization name
    protected noWhitespaceValidator(control: AbstractControl): ValidationErrors | null {
    const isWhitespace = (control.value || '').trim().length === 0;
    return isWhitespace ? { whitespace: true }: null;
}

}
